import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import Button from '../../components/elements/Button';
import Text from '../../components/fields/Text';
import styles from './styles.scoped.css';

export function Component({ handleSubmit, onBack = () => {} }) {
  const categoryField = {
    label: 'Tambah Kategori',
    name: 'addCategory',
  };

  return (
    <form onSubmit={handleSubmit}>
      <Field component={Text} inputProps={categoryField} name="addCategory" />

      <div className={styles['form-action']}>
        <Button onClick={onBack} outlined={true}>
          Kembali
        </Button>
        <Button>Simpan</Button>
      </div>
    </form>
  );
}

Component.propTypes = {
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'category',
  initialValues: {
    addCategory: '',
  },
})(Component);
